export default "__VITE_ASSET__CwamF99o__"